// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"cfe6eca346bdc8cc5b03","691":"1de73fea2d54a9fccb83"}[chunkId] + ".js";
};